<template>
	<!-- begin #footer -->
	<div id="footer" class="footer text-center" style="border-top: 1px solid #e4e4e4" v-bind:class="{ 'page-sidebar-minified': pageOptions.pageSidebarMinified }">
		QTrust - Copyright &copy; 2023. All Rights Reserved.
	</div>
	<!-- end #footer -->
</template>

<script>
import PageOptions from '@/Options/PageOptions.js'
import {version} from './../../../package.json'

export default {
  name: 'Footer',
  data() {
		return {
			pageOptions: PageOptions,
			version
		}
  }
}
</script>

<style scoped>
	.footer {
		margin: 0 0 0 220px;
	}

	/* Adjust footer margin when sidebar is minified (typically 60px width) */
	.footer.page-sidebar-minified {
		margin-left: 60px;
	}
</style>